import { render } from "./OrgTeam.vue.js?vue&type=template&id=20a9fd3e!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./OrgTeam.vue?vue&type=template&id=20a9fd3e"
import script from "./OrgTeam.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./OrgTeam.vue?vue&type=script&lang=js"
export * from "./OrgTeam.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./OrgTeam.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/directory/OrgTeam.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20a9fd3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20a9fd3e', __exports__)) {
    api.reload('20a9fd3e', __exports__)
  }
  
  module.hot.accept("./OrgTeam.vue.js?vue&type=template&id=20a9fd3e!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./OrgTeam.vue?vue&type=template&id=20a9fd3e", () => {
    api.rerender('20a9fd3e', render)
  })

}


export default __exports__